<template>
  <div>
    <app-gridview v-bind:parentData="{
      pageTitle: this.pageTitle,
      tabHeaders: this.dataHeader,
      tabItems: this.dataItems,
      search: this.search,
      isAdvanceEdit: true,
      isDelete: true,
    }" 
    v-on:AdvanceEditItem="advanceEditItemHandler($event)" 
    v-on:EditItem="editItemHandler($event)"
    v-on:DeleteItem="deleteItemHandler($event)" 
    v-on:NewPressed="newRecordHandler">
    </app-gridview>
    <div v-if="isConfirm">
      <app-confirm
          v-bind:parentObject="{
          messageConfirm: this.messageConfirm,
          isConfirm: this.isConfirm,
          }"
          v-on:confirm="deleteItemHandlerAction"
          v-on:cancelConfirm="isConfirm = !isConfirm"
      />
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import GridView from "../../../components/common/GridView";
import ConfirmDialog from "../../../components/common/ConfirmDialog";

export default {
  components: {
    "app-gridview": GridView,
    "app-confirm": ConfirmDialog,
  },

  data() {
    return {
      pageTitle: this.$t('pmassementrecord.pmassessmentrecordlist'),
      dataHeader: [
        { text: '', value: "action", sortable: false, width: "120px" },
        { text: this.$t('pmassementrecord.pmassessmentcode') , value: "pmassessmentrecordcode", sortable: false, width: "100px" },
        { text: this.$t('pmassementrecord.pmassessmentdesc'), value: "pmassessmentrecorddesc", width: "150px" },
        { text: this.$t('pmassementrecord.pmassessmentperiodfrom'), value: "startdate", width: "100px" },
        { text: this.$t('pmassementrecord.pmassessmentperioduntil'), value: "enddate", width: "100px" },
        // { text: 'Rating Type', value: "ratingtype", width: "50px" },
        { text: this.$t('pmassementrecord.pmassessmentratingtype'), value: "ratingtypename", width: "50px" },
      ],
      dataItems: [],
      loading: false,
      errMsg: '',
      isConfirm: false,
      messageConfirm:'',
      selectedItem: null,
      search: this.$route.params.search,
    };
  },

  methods: {
    getPmAssessmentRecordHandler() {
      const vm = this;
      this.loading = !this.loading;
      this.$store.dispatch('get', { url: "/performanceassessmentrecord/all" })
        .then(function (res) {
          vm.dataItems = res.data.rec;
          for (let i = 0; i < vm.dataItems.length; i++) {
            if (vm.dataItems[i].startdate) {
              vm.dataItems[i].startdate = moment(vm.dataItems[i].startdate).format('YYYY-MM-DD');
            }

            if (vm.dataItems[i].enddate) {
              vm.dataItems[i].enddate = moment(vm.dataItems[i].enddate).format('YYYY-MM-DD');
            }
            if (vm.dataItems[i].ratingtype === 1) {
              vm.dataItems[i].ratingtype = 'Rank';
            } else if (vm.dataItems[i].ratingtype === 2) {
              vm.dataItems[i].ratingtype = 'Grid';
            }//Hard coded
          }
          vm.loading = !vm.loading;
        })
        .catch(function (err) {
          vm.errMsg = err;
        });
    },

    newRecordHandler() {
      this.$router.push({ name: "performanceassessmentrecordnew" });
    },
    
    advanceEditItemHandler(item) {
      this.$router.push({
        name: "performanceassessmentrecordstaff",
        params: { id: item.id },
      });
    },

    editItemHandler(item) {
      this.$router.push({ name: "performanceassessmentrecordedit", params: { id: item.id,search: item.search } });
    },
    
    deleteItemHandler(item) {
      this.messageConfirm = this.$t('pmassementrecord.deleteconfirm', { code: item.pmassessmentrecordcode });
      this.selectedItem = item;
      this.isConfirm=true;
    },
    deleteItemHandlerAction() {
      const vm = this;

      if (!this.selectedItem) {
          console.error(" No item selected for deletion!");
          return;
      }
      const deleteUrl = "/performanceassessmentrecord/" + vm.selectedItem.id + '/' + this.$store.getters.userId;

      if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
        return false;
      }
      this.$store.dispatch('delete', {url: deleteUrl})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            window.location.reload();
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
      vm.selectedItem = null; // 🔹 Clear after deletion
      this.isConfirm = false;  // 🔹 Close confirmation dialog
    },
  },

  mounted() {
    this.getPmAssessmentRecordHandler();
  },
};
</script>